module.exports = __webpack_public_path__ + "static/media/main_slider_3.c5c1c122.jpg";